import React from 'react';
import { Box, Typography } from '@mui/material';
import { keyframes } from '@mui/system';

const bounce = keyframes`
  0%, 60%, 100% { transform: translateY(0); opacity: 0.45; }
  30% { transform: translateY(-4px); opacity: 1; }
`;

/**
 * Subtle "user is typing" row with bouncing dots.
 */
export default function TypingIndicator({ label = 'Typing…' }) {
  return (
    <Box
      className="chat-typing-indicator"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.75,
        px: 1,
        py: 0.75,
        color: 'text.secondary',
      }}
      aria-live="polite"
      aria-label={label}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
        {[0, 1, 2].map((i) => (
          <Box
            key={i}
            component="span"
            sx={{
              width: 5,
              height: 5,
              borderRadius: '50%',
              bgcolor: 'text.disabled',
              animation: `${bounce} 1.2s ease-in-out infinite`,
              animationDelay: `${i * 0.15}s`,
            }}
          />
        ))}
      </Box>
      <Typography variant="caption" sx={{ color: 'text.secondary', fontStyle: 'italic' }}>
        {label}
      </Typography>
    </Box>
  );
}
